// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styles/" + {"641":"verbisbox-station-list","646":"verbisbox-station"}[chunkId] + "." + {"641":"361122ba6918e8db1a02","646":"efdb01dddc8c338b097d"}[chunkId] + ".css";
};